<template>
  <div class="month-picker" :class="{ 'hidden' : !isOpen }">
    <div class="fixed inset-0 bg-gray-900 opacity-75" />
    <div class="fixed inset-0 my-8 mx-4 bg-gray-200 p-4 rounded-md shadow-md flex flex-col items-center">
      <div class="text-sm uppercase font-bold mb-4">
        Pilih Cabang
      </div>
      <a v-for="(branch, index) in branches" :key="index" class="flex flex-col self-stretch overflow-y-auto h-auto" @click="onChoose(branch)">
        <div class="shadow-md text-sm my-1 bg-gray-100 self-stretch text-center py-2 px-2 uppercase">
          {{ branch.name }}
          <br>
          <span class="text-xs font-serif">{{ branch.address }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SelectBranch',
  props: {
    userId: {
      type: Number,
      default: null
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      isOpen: false
    }
  },
  computed: {
    ...mapGetters('branch', ['branches'])
  },
  mounted () {
    this.isLoading = true
    this.get({
      params: {
        project_id: this.projectId
      }
    }).then(response => {
      this.isLoading = false
    }).catch(error => {
      this.isLoading = false
      console.log(error)
    })
  },
  methods: {
    ...mapActions('branch', ['get']),
    ...mapActions('userBranch', {
      updateUserBranch: 'update'
    }),
    onChoose (branch) {
      this.updateUserBranch({
        user_id: this.userId,
        project_id: this.projectId,
        branch_id: branch.id
      }).then(response => {
        this.$emit('choosen', true)
        this.isLoading = false
        this.close()
      }).catch(error => {
        this.isLoading = false
        console.log(error)
      })
    },
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>

<style>
.month-picker {
  animation: 1s appear;
}

@keyframes appear {
  0% {
    opacity: 0;
  }
}
</style>
